import LayoutContainer from 'components/Common/LayoutContainer'
import React from 'react'
import styled from 'styled-components'
import NavigationNavItems from './NavigationHeader/NavigationNavItems'

const NavigationSubHeaderWrapper = styled.div`
  background: ${props => props.theme.palette.neutral.eight};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};
`

const SubHeaderBar = React.forwardRef<HTMLDivElement>((props, ref) => {
  return <NavigationSubHeaderWrapper ref={ref}>
    <LayoutContainer>
      <NavigationNavItems />
    </LayoutContainer>
  </NavigationSubHeaderWrapper>
})

export default SubHeaderBar
